<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.382,0C13.7607,1.04064e-15,14.107,0.214002,14.2764,0.552786C14.2764,0.552786,16,4,16,4C16,4,16,15,16,15C16,15.5523,15.5523,16,15,16C15,16,1,16,1,16C0.447715,16,6.76354e-17,15.5523,0,15C0,15,0,4,0,4C0,4,1.72361,0.552786,1.72361,0.552786C1.893,0.214002,2.23926,2.91624e-16,2.61803,0C2.61803,0,13.382,0,13.382,0C13.382,0,13.382,0,13.382,0ZM8,6C7.45,6,7,6.45,7,7C7,7,7,7,7,7C7,7,7,9.59,7,9.59C7,9.59,6.71,9.3,6.71,9.3C6.71,9.3,6.62869,9.22356,6.62869,9.22356C6.45796,9.08082,6.24,9,6,9C5.45,9,5,9.45,5,10C5,10.28,5.11,10.53,5.29,10.71C5.29,10.71,5.29,10.71,5.29,10.71C5.29,10.71,7.29,12.71,7.29,12.71C7.29,12.71,7.38565,12.794,7.38565,12.794C7.55417,12.9236,7.76667,13,8,13C8.28,13,8.53,12.89,8.71,12.71C8.71,12.71,8.71,12.71,8.71,12.71C8.71,12.71,10.71,10.71,10.71,10.71C10.71,10.71,10.794,10.6144,10.794,10.6144C10.9236,10.4458,11,10.2333,11,10C11,9.45,10.55,9,10,9C9.72,9,9.47,9.11,9.29,9.29C9.29,9.29,9.29,9.29,9.29,9.29C9.29,9.29,9,9.59,9,9.59C9,9.59,9,7,9,7C9,7,8.99324,6.8838,8.99324,6.8838C8.9352,6.38801,8.51071,6,8,6C8,6,8,6,8,6ZM13,2C13,2,3,2,3,2C3,2,2,4,2,4C2,4,14,4,14,4C14,4,13,2,13,2C13,2,13,2,13,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Archive',
} as DefineComponent
</script>
